var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserFill = function SvgUserFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#283E4C",
    d: "M24 4c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10S29.514 4 24 4M42 40v2H6v-2c0-7.718 6.28-14 14-14h8c7.718 0 14 6.282 14 14"
  })));
};
export { SvgUserFill as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDRDMTguNDg2IDQgMTQgOC40ODYgMTQgMTRDMTQgMTkuNTE0IDE4LjQ4NiAyNCAyNCAyNEMyOS41MTQgMjQgMzQgMTkuNTE0IDM0IDE0QzM0IDguNDg2IDI5LjUxNCA0IDI0IDRaIiBmaWxsPSIjMjgzRTRDIi8+CjxwYXRoIGQ9Ik00MiA0MFY0MkgxMEg2VjQwQzYgMzIuMjgyIDEyLjI4IDI2IDIwIDI2SDI4QzM1LjcxOCAyNiA0MiAzMi4yODIgNDIgNDBaIiBmaWxsPSIjMjgzRTRDIi8+Cjwvc3ZnPgo=";